'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  cursor: pointer;\n  position: static;\n  width: 30px;\n  min-width: 30px;\n  min-height: 30px;\n  height: 30px;\n  margin-right: 32px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n'], ['\n  cursor: pointer;\n  position: static;\n  width: 30px;\n  min-width: 30px;\n  min-height: 30px;\n  height: 30px;\n  margin-right: 32px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  &, &:before, &:after {\n    width: 24px;\n    height: 2px;\n    border-radius: 2px;\n    background-color: #4a4a4a;\n    position: absolute;\n    display: block;\n    content: "";\n  }\n  &:before {\n    top: -8px;\n  }\n  &:after {\n    top: 8px;\n  }\n'], ['\n  &, &:before, &:after {\n    width: 24px;\n    height: 2px;\n    border-radius: 2px;\n    background-color: #4a4a4a;\n    position: absolute;\n    display: block;\n    content: "";\n  }\n  &:before {\n    top: -8px;\n  }\n  &:after {\n    top: 8px;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClickArea = _styledComponents2.default.div(_templateObject);

var HamburgerLayout = _styledComponents2.default.div(_templateObject2);

var Hamburger = function Hamburger(props) {
  return _react2.default.createElement(
    ClickArea,
    props,
    _react2.default.createElement(HamburgerLayout, null)
  );
};

Hamburger.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

exports.default = Hamburger;